import * as preact from "preact";
import { $$ } from "../../Core/Common";
import { BaseComponent, IBaseComponentProps } from "../../Common/BaseComponent/BaseComponent";
import { $$videoPlayer } from "../../Common/VideoPlayer/VideoPlayer";
import { $$app } from "../../Core/Application";
import { EventViewer } from "../EventViewer/EventViewer";

import TimelineModel = EventLibrary.Model.Timeline;
import TimeGroup = EventLibrary.Model.TimeGroup;
import FlexDate = EventLibrary.Shared.FlexDate;
import DatePrecision = EventLibrary.Shared.DatePrecision;
import EventInstance = EventLibrary.Model.EventInstance;

interface IProps extends IBaseComponentProps
{
    Timeline?: TimelineModel;
}

interface IState
{
    Timeline?: TimelineModel;
}

export class Timeline extends BaseComponent<IProps, IState>
{
    private _eventViewer: EventViewer;
    private _pnlSideBar: HTMLElement;

    constructor(props)
    {
        super(props);
    }

    public setTimeline(timeline: TimelineModel)
    {
        this.setState({ Timeline: timeline });
    }

    public loadEvent(eventId: string)
    {
        this._eventViewer.load(eventId);
    }

    private _onEventLoad()
    {

        this._pnlSideBar.style.right = (document.documentElement.clientWidth - this.Container.clientWidth - 40) / 2 + "px";
        this._pnlSideBar.style.display = "";
        $$.show(this._pnlSideBar);
        if ($$app.getIsMobile())
        {
            document.body.style.top = `-${window.scrollY}px`;
            document.body.classList.add("modalOpen");
        }
        //this._slideReveal.slideReveal("show");
    }

    private _getGroupHeader(grouping: DatePrecision, groupIndex: FlexDate): string
    {
        var groupHeader;
        switch (grouping)
        {
            case 2:  //date
                break;
            case 3:  //months
                break;
            case 4:  //years
                groupHeader = groupIndex.RawYear;
                if (groupHeader < 0)
                {
                    groupHeader = (groupHeader * -1) + " BC";
                }
                else if (groupHeader < 1000)
                {
                    groupHeader = groupHeader + " AD";
                }
                break;
        }
        return groupHeader;
    }

    private _renderTimeline(timeline: TimelineModel)
    {
        if (!timeline)
        {
            return null
        }

        var groups = timeline.Groups;
        var grouping = timeline.GroupBy;

        return (
            <preact.Fragment>
                {
                    groups.map((timeGroup: TimeGroup) =>
                    {
                        let groupIndex = timeGroup.StartDate;
                        let events = timeGroup.Events;
                        if (events.length === 0)
                        {
                            return null;
                        }

                        return (
                            <div class="eventGroup">
                                <div class="eventGroupHeader">
                                    {
                                        this._getGroupHeader(grouping, groupIndex)
                                    }
                                </div>
                                <div class="eventsWrapper">
                                    {
                                        events.map((event: EventInstance) =>
                                        {
                                            return this._renderEvent(event);
                                        })
                                    }
                                </div>
                            </div>
                        );
                    })
                }
            </preact.Fragment>
        );   
    }

    _renderEvent(event): preact.JSX.Element
    {
        return (<div className="event" data-event-id={event.Id}>
            <div className="eventStart">
                <div className="timepoint"></div>
                {$$.lineDate(event.Start)}
            </div>
            <div style={{ display: "flex" }}>
                <div style={{ flex: "1" }}>
                    <div className="eventTitle">{event.Name}</div>
                    <div className="eventTeaser">{event.Teaser}</div>
                </div>

                <div style={{ marginRight: "5px", textAlign: "right", paddingLeft: "3px" }}>
                    {
                        !event.Images?.length ? null : (<img className="timelineImage" src={"api/image/GetImage?thumb=1&id=" + event.Images[0].Id} loading="lazy" />)
                    }

                    {
                        (event.Images?.length > 0 || !event.Videos?.length) ? null : (<div data-id={event.Videos[0].Id} className="videoThumb" key={event.Videos[0].Id}>
                            <img src={"https://img.youtube.com/vi/" + event.Videos[0].Id + "/1.jpg"} loading="lazy" />
                        </div>)
                    }
                </div>
            </div>
        </div>);
    }

    _onPnlResultsClick(evt)
    {
        var pnlEvent = $$.getParent(evt.target, "div", "event");
        if (pnlEvent)
        {
            this._eventViewer.load(pnlEvent.dataset.eventId);
        }
    }

    private _onBodyClick(evt)
    {
        let overlay = document.getElementsByClassName("overlay")[0] as HTMLElement;
        if (overlay && overlay.style.display !== "none")
        {
            return;
        }

        var container = $$.getParent(evt.target, "div", "sideBar");
        var viewer = $$.getParent(evt.target, "div", "viewer-container");
        var event = $$.getParent(evt.target, "div", "event");
        if (!container && !viewer && !event)
        {
            this._closeSideBar();
            //this._slideReveal.slideReveal("hide");
        }
    }

    private _closeSideBar(): void
    {
        if ($$app.getIsMobile())
        {
            let scrollY = document.body.style.top;
            document.body.classList.remove("modalOpen");
            document.body.style.top = '';
            window.scrollTo(0, parseInt(scrollY || '0') * -1);
        }
        $$.hide(this._pnlSideBar);
    }

    public override componentDidMount()
    {
        super.componentDidMount();

        document.addEventListener("click", this._onBodyClick.bind(this));
        document.addEventListener("keydown", this._onBodyKeydown.bind(this));

        /*
        setTimeout(() =>
        {
            this._slideReveal = ($(this._pnlSideBar) as any).slideReveal({ position: "right", width: "600px", push: false });
        });
        */
    }

    private _onCloseClick()
    {
        this._closeSideBar();
    }

    private _onBodyKeydown(evt: KeyboardEvent)
    {
        if (evt.keyCode === 27)
        {
            if ($$videoPlayer.isOpen())
            {
                $$videoPlayer.close();
            }
            else if (this._pnlSideBar.style.display !== "none")
            {
                this._closeSideBar();
            }
        }
    }

    render(props: IProps, state: IState)
    {
        return (
            <div ref={(ref) => this._registerContainer(ref)} style={{ width: "100%" }} >
                <div class="timelineLeftPane">
                    <div onClick={this._onPnlResultsClick.bind(this)} style={{ marginLeft: "5px" }}>
                        {
                            this._renderTimeline(props.Timeline || state.Timeline)
                        }
                    </div>
                </div>

                <div ref={(ref) => { this._pnlSideBar = ref; }} className="sideBar" style={{ display: "none" }}>
                    <a href="javascript:void(0);" className="closeButton" onClick={this._onCloseClick.bind(this)}>X</a>
                    <EventViewer ref={(ref) => { this._eventViewer = ref; }} onLoad={this._onEventLoad.bind(this)} />
                </div>
            </div>
        );
    }
}